module.exports ={
  invalidKey: function() {
    return 'Event key must be a string';
  },
  unknownCustomEventKey: function(key) {
    return 'Custom event "' + key + '" does not exist'
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/ldclient-js/src/messages.js
// module id = 1052
// module chunks = 0